var _defs, _ellipse, _rect, _line, _rect2, _circle, _circle2, _rect3, _line2, _polygon, _polyline, _polyline2, _polyline3, _polyline4, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineSpokesmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-70%",
    y: "-70%",
    width: "240%",
    height: "240%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 7
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 128,
    rx: 27,
    ry: 46,
    fill: "none",
    stroke: "#37B0A5",
    strokeWidth: 13,
    filter: "url(#glow)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0.7;0;0;0.7",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 90,
    width: 46,
    height: 96,
    fill: "none",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.55;0.55;0",
    keyTimes: "0;0.45;0.58;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 100,
    y2: 4,
    stroke: "#8A8A8A",
    strokeWidth: 0.9,
    strokeDasharray: "3,7",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.4;0.4;0",
    keyTimes: "0;0.45;0.58;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 94,
    width: 16,
    height: 16,
    rx: 8,
    ry: 8,
    fill: "#37B0A5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "8;8;0;0;8",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "8;8;0;0;8",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "92;92;90;90;92",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "16;16;20;20;16",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 103,
    r: 1.6,
    fill: "#000",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;1;0;0;1",
    keyTimes: "0;0.28;0.48;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 1.6,
    fill: "#000",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;1;0;0;1",
    keyTimes: "0;0.28;0.48;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 101,
    width: 16,
    height: 4,
    fill: "#000",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.85;0.85;0",
    keyTimes: "0;0.48;0.58;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 110,
    x2: 100,
    y2: 114,
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "89,114 111,114 108,140 92,140",
    fill: "#37B0A5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "points",
    values: "89,114 111,114 108,140 92,140;89,114 111,114 108,140 92,140;89,114 111,114 111,140 89,140;89,114 111,114 111,140 89,140;89,114 111,114 108,140 92,140",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "89,118 82,131 80,144",
    fill: "none",
    stroke: "#37B0A5",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "111,118 118,131 120,144",
    fill: "none",
    stroke: "#37B0A5",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "95,140 100,158 105,177",
    fill: "none",
    stroke: "#37B0A5",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "points",
    values: "95,140 100,158 105,177;95,140 100,158 105,177;95,140 94,158 93,177;95,140 94,158 93,177;95,140 100,158 105,177",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "105,140 100,158 97,177",
    fill: "none",
    stroke: "#37B0A5",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "points",
    values: "105,140 100,158 97,177;105,140 100,158 97,177;105,140 106,158 107,177;105,140 106,158 107,177;105,140 100,158 97,177",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 177,
    x2: 108,
    y2: 177,
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x1",
    values: "102;102;90;90;102",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "108;108;96;96;108",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 177,
    x2: 100,
    y2: 177,
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x1",
    values: "94;94;104;104;94",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "100;100;110;110;100",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#37B0A5;#37B0A5;#8A8A8A;#8A8A8A;#37B0A5",
    keyTimes: "0;0.28;0.52;0.75;1",
    dur: "5s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineSpokesmen);
export default __webpack_public_path__ + "static/media/MachineSpokesmen.38e349c3f2d290e225fac25b177a5b11.svg";
export { ForwardRef as ReactComponent };